<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="item" v-for="(item, index) in dataList" :key="index">
        <div class="top">
          <div class="left">
            <div class="left-left">
              <span>{{ item.companyName.slice(0, 2) }}</span>
            </div>
            <div class="left-right">
              <div class="left-item">
                <van-popover
                  trigger="click"
                  v-model="item.showPopover"
                  placement="top"
                >
                  <template #reference>
                    <span class="omit">{{ item.companyName }}</span>
                  </template>
                  <div class="all">
                    {{ item.companyName }}
                  </div>
                </van-popover>

                <span class="followed">{{
                  item.followed ? "已跟进" : "未跟进"
                }}</span>
              </div>
              <div class="left-item">
                <span>{{ item.xcCompanyInfo.legalPersonName }}</span>
                <span
                  v-if="item.xcCompanyInfo && item.xcCompanyInfo.contactInfo"
                  >{{ item.xcCompanyInfo.contactInfo }}</span
                >
              </div>
            </div>
          </div>
          <div class="right">
            <span @click="toPage('maintainRecords', item)">写跟进</span>
          </div>
        </div>
        <div class="bottom">
          <div @click="toApplyDialogShow = !toApplyDialogShow">
            <img
              src="https://static.xchengtech.cn/1a9c3f9e3c294c9887e5b949ee063da5.png"
              alt=""
            />
            <span>引导进件</span>
          </div>
          <div @click="toCall(item.xcCompanyInfo)">
            <img
              src="https://static.xchengtech.cn/bc3a408f371f49db80b9193ed34bdfed.png"
              alt=""
            /><span>联系客户</span>
          </div>
          <div @click="toCompanydetai(item.id)">
            <img
              src="https://static.xchengtech.cn/2c8b117d63034ec98bd3d7a16331ad2d.png"
              alt=""
            />
            <span>详细资料</span>
          </div>
        </div>
      </div>
    </van-list>
    <!-- 快捷选项：产品 -->
    <van-popup
      v-model="toApplyDialogShow"
      position="bottom"
      round
      style="max-height: 70%"
    >
      <div class="popupDiv">
        <!-- <div class="title">选择产品</div> -->
        <div class="popupDiv-content">
          <van-picker
            title="选择产品"
            value-key="productName"
            show-toolbar
            :columns="productList"
            @confirm="toApplyDialogOnConfirm"
            @cancel="toApplyDialogShow = !toApplyDialogShow"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Button,
  RadioGroup,
  Radio,
  Toast,
  Notify,
  Picker,
  Form,
  Empty,
  List,
  Field,
  Dialog,
  Collapse,
  CollapseItem,
  Popover,
} from "vant";
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(List);
Vue.use(Form);
Vue.use(Collapse);
Vue.use(CollapseItem);
import Vue from "vue";
import { xcCustomer } from "@/api/xcCustomer";
import { xcProductDict } from "@/api/product.js";
export default {
  created() {
    // 获取产品列表
    this.getProductList();
  },
  data() {
    return {
      query: {
        size: 10,
        page: 0,
        sort: "createDateTime,desc",
        createDateTime: [],
      },
      dataList: [],
      loading: false,
      finished: false,
      toApplyDialogShow: false,
      productList: [],
    };
  },
  methods: {
    // 获取企业详情信息
    toCompanydetai(id) {
      this.$router.push({
        path: "/companyDetail",
        query: { id: id },
      });
    },
    // 获取产品列表
    getProductList() {
      xcProductDict()
        .then((res) => {
          this.productList = res;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    toApplyDialogOnConfirm(e) {
      this.toProductPoster(e.id);
    },
    toProductPoster(id) {
      this.$router.push({
        path: "/productPoster",
        query: { productId: id },
      });
    },
    onLoad() {
      this.loading = true;
      this.getXcCustomerData();
    },
    onSearch() {
      this.query.page = 0;
      this.finished = false;
      this.loading = true;
      this.dataList = [];
      this.getXcCustomerData();
    },
    // 获取订单数据
    getXcCustomerData() {
      if (!this.query.companyNameLike) delete this.query.companyNameLike;
      xcCustomer(this.query)
        .then((res) => {
          console.log("res", res);
          this.dataList = this.dataList.concat(res.content);
          this.loading = false;
          this.query.page++;
          if (res.content.length == 0) {
            this.finished = true;
          }
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    toPage(name, item) {
      switch (name) {
        case "toApply":
          break;
        case "maintainRecords":
          this.$router.push({
            path: "/" + name,
            query: { id: item.enterpriseId, customerId: item.id },
          });
          break;
      }
    },
    toCall(item) {
      window.open("tel:" + item.contactInfo);
    },
  },
};
</script>

<style scoped>
.item {
  padding: 4vw;
  background-color: #ffffff;
  margin-bottom: 5vw;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.item:nth-last-of-type(1) {
  margin-bottom: 0;
}
.item .top {
  display: grid;
  grid-template-columns: auto 14vw;
  padding-bottom: 4vw;
  align-items: center;
}
.item .top .left {
  display: flex;
  align-items: center;
  gap: 4vw;
}
.item .top .left .left-left {
}
.item .top .left .left-left span {
  display: inline-block;
  width: 12vw;
  height: 12vw;
  line-height: 12vw;
  text-align: center;
  border-radius: 999px;
  background-color: #4e8eff;
  color: white;
}
.item .top .left .left-right {
  display: grid;
  gap: 2vw;
}
.item .top .left .left-right .left-item:nth-of-type(1) {
  display: grid;
  grid-template-columns: auto 12vw;
  gap: 1vw;
}

.item .top .left .left-right .left-item:nth-of-type(1) span:nth-of-type(1) {
  font-weight: 600;
  font-size: 4vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.van-popup .all {
  padding: 2vw;
}
.item .top .left .left-right .left-item:nth-of-type(1) .followed {
  color: #4e8eff;
}
.item .top .left .left-right .left-item:nth-of-type(2) {
  display: flex;
  align-items: baseline;
  gap: 2vw;
  color: #838383;
}

.item .top .right {
  text-align: right;
}
.item .top .right span {
  border-radius: 35px;
  border: 1px solid #4e8eff;
  color: #4e8eff;
  padding: 2px 4px;
  font-size: 3.2vw;
}
.item .bottom {
  border-top: 1px solid #f4f4f4;
  padding-top: 4vw;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  text-align: center;
  color: #838383;
}
.item .bottom div {
  display: flex;
  align-items: center;
  gap: 1vw;
  justify-content: center;
}
.item .bottom div img {
  display: block;
  width: 4vw;
}
</style>


// WEBPACK FOOTER //
// src/view/myCustomer/module/dkkhData/index.vue